import type { CondominiumOption } from '@brimostech/shared';

export interface OptionGroup {
  organizationName: string;
  options: CondominiumOption[];
}

/** Groups selectable condominiums by organization, keeping the incoming (alphabetical) order. */
export function groupOptionsByOrganization(options: CondominiumOption[]): OptionGroup[] {
  const groups = new Map<string, CondominiumOption[]>();
  for (const option of options) {
    const list = groups.get(option.organizationName) ?? [];
    list.push(option);
    groups.set(option.organizationName, list);
  }
  return [...groups.entries()].map(([organizationName, list]) => ({
    organizationName,
    options: list,
  }));
}
